import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const selectableCharacterInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("selectable-character").default("selectable-character"),
      selected: z.boolean().default(false)
    }),
    shouldValidate: (node, entry) => node.validation.shouldBeMarked || !!entry?.selected,
    validate: (node, entry) => node.validation.shouldBeMarked === entry.selected,
    // NB: items here consists of an entire word.
    parseLegacyDetailItem: (item, context) => {
      if (["SelectAnswers"].includes(context.relatedTask.taskType) && ["MarkCharacters"].includes(context.relatedTask.answerType ?? "") && Array.isArray(item)) {
        const task = context.relatedTask;
        const inputsInWord = [];
        let wordIndex = 0;
        for (const segment of task.content) {
          if (segment.nodeType === "mark-characters-whitespace") {
            wordIndex++;
          } else if (wordIndex === context.indexInDetails) {
            inputsInWord.push(segment);
          } else if (wordIndex > context.indexInDetails) {
            break;
          }
        }
        return inputsInWord.map((input, index) => [input.id, {
          type: "selectable-character",
          selected: item[index]
        }]);
      }
    }
  },
  schema: z.object({
    character: z.string(),
    correctAnswer: z.boolean().default(false)
  }),
  postprocessSchemaInput: ({
    correctAnswer,
    ...input
  }, context) => {
    return {
      ...input,
      id: `${context.taskId}-${context.index}`,
      nodeType: "selectable-character-input",
      validation: {
        shouldBeMarked: correctAnswer
      }
    };
  }
});

export { selectableCharacterInput };
//# sourceMappingURL=input.selectable-character.js.map
